import { useEffect, useRef, useState } from 'react'

/**
 * @param initFunction A function to call for initialization. Do not pass an inline function or this will continuously call it
 * @returns whether the initialization function is in progress, succeeded, failed, or still idle
 */
export const useAsyncInitialization = (
  initFunction: () => Promise<void>
) => {
  const [loadingState, setLoadingState] = useState<'finished' | 'error' | 'loading'>('loading')
  const mountedRef = useRef(false)

  useEffect(() => {
    const doInit = async () => {
      if (mountedRef.current) {
        setLoadingState('loading')
      }
      try {
        await initFunction()
        if (mountedRef.current) {
          setLoadingState('finished')
        }
      } catch (error) {
        if (mountedRef.current) {
          setLoadingState('error')
        }
      }
    }

    doInit()
  }, [setLoadingState, initFunction])

  useEffect(() => {
    mountedRef.current = true

    return () => {
      mountedRef.current = false
    }
  }, [])

  return loadingState
}
